// store.js
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import headernavbarReducer from "./headernavbarReducer";

const store = createStore(headernavbarReducer, applyMiddleware(thunk));

export default store;
